<template>
<el-drawer size="80%" :destroy-on-close="true" :visible.sync="visible" @close="$emit('input', false)" :wrapperClosable="false">
    <div slot="title" style="font-size: 1.2rem; font-weight: bold">排课</div>
    <div style="padding: 1rem">
        <el-form :inline="true">
            <el-form-item label="学生姓名">
                <el-input v-model.trim="dataForm.realName" placeholder="学生姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="账户名">
                <el-input v-model.trim="dataForm.userName" placeholder="账户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="班级" prop="studentGroupId">
                <!--     <el-dict-select
            placeholder="班级"
            v-model="dataForm.studentGroupId"
            @change="classSelected(val)"
            type="studentGroups"
            :props="{ label: 'groupName', value: 'id' }"
          ></el-dict-select>-->
                <el-select v-model="dataForm.studentGroupId" placeholder="请选择班级" clearable @change="classSelected" filterable>
                    <el-option v-for="(item, index) in this.groupOptions" :key="String(index)" :value="item.id" :label="item.groupName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="班主任">
                <el-dict-select placeholder="班主任" v-model="dataForm.teacherId" type="teacherSelects" :props="{ label: 'realName', value: 'userId' }"></el-dict-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-dict-select placeholder="状态" v-model="dataForm.classStatus" type="listByType" :props="{ label: 'value', value: 'code' }" :params="classStatusParams"></el-dict-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="rgetDataList()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-form :inline="true" ref="submitForm" :model="submitForm" :rules="submitFormRules">
            <el-form-item label="排课日期" required>
                <el-form-item prop="sDate">
                    <el-date-picker style="flex: 3" v-model="submitForm.sDate" align="right" :picker-options="pickerOptions" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="sTime">
                    <el-time-select style="flex: 2" placeholder="起始时间" v-model="submitForm.sTime" :picker-options="{
                start: '09:00',
                step: '00:15',
                end: '21:30',
              }">
                    </el-time-select>
                </el-form-item>
                <el-form-item prop="eTime">
                    <el-time-select style="flex: 2" placeholder="结束时间" v-model="submitForm.eTime" :picker-options="{
                start: '09:00',
                step: '00:15',
                end: '21:30',
                minTime: submitForm.sTime,
              }">
                    </el-time-select>
                </el-form-item>
            </el-form-item>
            <el-form-item label="任课老师" prop="userId">
                <el-dict-select placeholder="任课老师" v-model="submitForm.userId" type="teacherSelects" :props="{ label: 'realName', value: 'userId' }"></el-dict-select>
            </el-form-item>
        </el-form>
        <el-row style="margin-bottom: 1rem">
            <el-col>
                <el-button size="small" type="primary" :disabled="!selected.length" @click="duopai">批量排课</el-button>
            </el-col>
        </el-row>
        <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="realName" header-align="center" align="center" label="姓名">
            </el-table-column>
            <el-table-column prop="username" header-align="center" align="center" label="账户名">
            </el-table-column>
            <el-table-column prop="gender" header-align="center" align="center" label="性别">
                <template slot-scope="{ row }">
                    {{ getSysDictVal("Gender", row.gender) }}
                </template>
            </el-table-column>
            <el-table-column prop="studentGroupName" header-align="center" align="center" label="班级">
            </el-table-column>
            <el-table-column header-align="center" align="center" label="学段">
                <template slot-scope="{ row }">
                    {{ getSysDictVal("StudentStage", row.userStage) }}
                </template>
            </el-table-column>
            <el-table-column prop="userStageLevel" header-align="center" align="center" label="阶段">
                <template slot-scope="{ row }">
                    {{ getSysDictVal("StudentStageLevel", row.userStageLevel) }}
                </template>
            </el-table-column>

            <el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
                <template slot-scope="{ row }">
                    <el-button type="text" @click="danpai(row.userId)">排课</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
</el-drawer>
</template>

<script>
export default {
    props: {
        value: Boolean,
    },
    watch: {
        value(val) {
            this.visible = val;
        },
    },
    data() {
        return {
            visible: false,
            dataList: [],
            groupOptions: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataForm: {
                realName: undefined,
                userName: undefined,
                studentGroupId: undefined,
                // userStage: undefined,
                // userStageLevel: undefined,
                teacherId: undefined,
                status: undefined,
            },
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周后',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            submitForm: {
                sDate: "",
                sTime: "",
                eTime: "",
                userId: "",
            },
            submitFormRules: {
                sDate: {
                    required: true,
                    message: "请选择排课日期",
                    trigger: "change"
                },
                sTime: {
                    required: true,
                    message: "请选择开始日期",
                    trigger: "change"
                },
                eTime: {
                    required: true,
                    message: "请选择结束日期",
                    trigger: "change"
                },
                userId: {
                    required: true,
                    message: "请选择任课老师",
                    trigger: "change",
                },
            },
            selected: [],
        };
    },
    computed: {
        stageDictParams() {
            return {
                itemId: this.dataForm.itemId
            };
        },
        dictProps() {
            return {
                label: "value",
                value: "code"
            };
        },
        groupStageParams() {
            return {
                type: "StudentStage"
            };
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage
            };
        },
        classStatusParams() {
            return {
                type: "StudentClassStatus"
            };
        },
    },
    created() {
        this.getDataList();
        this.studentGroupOptions()
    },
    methods: {
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        classSelected(val) {
            this.$http({
                url: this.$http.adornUrl("course/studentGroup/info/" + val),
                method: "get",
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.submitForm.userId = data.studentGroup.userId
                    this.submitForm.sTime = data.studentGroup.startTime
                    this.submitForm.eTime = data.studentGroup.endTime
                }
            });
        },
        studentGroupOptions() {
            this.$http({
                url: this.$http.adornUrl("common/studentGroups"),
                method: "get",
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.groupOptions = data.data;
                }
            });
        },
        danpai(userId) {
            this.$refs.submitForm.validate((valid) => {
                if (valid) {
                    this.$emit("submit", {
                        ids: [userId],
                        params: {
                            endTime: this.submitForm.sDate + " " + this.submitForm.eTime + ":00",
                            startTime: this.submitForm.sDate + " " + this.submitForm.sTime + ":00",
                            userId: this.submitForm.userId,
                        },
                    });
                }
            });
        },
        duopai() {
            this.$refs.submitForm.validate((valid) => {
                if (valid) {
                    const ids = this.selected.map((i) => i.userId);
                    this.$emit("submit", {
                        ids,
                        params: {
                            endTime: this.submitForm.sDate + " " + this.submitForm.eTime + ":00",
                            startTime: this.submitForm.sDate + " " + this.submitForm.sTime + ":00",
                            userId: this.submitForm.userId,
                        },
                    });
                }
            });
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("sys/user/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    ...this.dataForm,
                    status: "1",
                    userType: "STUDENT",
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.dataList = data.page.list;
                    this.totalPage = data.page.totalCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
    },
};
</script>
